import Alpine from 'alpinejs';
import { PolyfillImages } from './modules/polyfills';
import { InitAccordion } from './modules/accordion';
import { InitHeaderMenu } from './modules/navigation';
import AlertNotice from './modules/alert_notice';
import { InitNews } from './modules/news';
import { InitInstagramFeed } from './modules/instagram_feed';
import { InitNumberCounter } from './modules/anim_numbers';
import InitModals from './modules/modal';
import CookieByte from './modules/cookie-byte';
import InitFilterSection from './modules/filter';
import ImageGallery from './modules/image-gallery';
import MediaViewer from './modules/media-viewer';
import SliderHero from './classes/slider-hero';
import Form from './form/form';

const siteInitialization = () => {
    PolyfillImages();
    InitHeaderMenu();
    CookieByte.init();
    InitAccordion();
    InitFilterSection();
    InitNews();
    InitInstagramFeed();
    InitNumberCounter();
    InitModals();
    ImageGallery.init();
    MediaViewer.init();
    SliderHero.initAll();
    AlertNotice.init();
    Form.init();
    
    window.Alpine = Alpine;	
    Alpine.start();

    // openSites();
};


function openSites() {
    const sitemap = {
        "urlset": {
          "url": [
            {
              "loc": "http://eudres.localhost",
              "lastmod": "2023-07-10T12:11:11+00:00",
              "priority": 1
            },
            {
              "loc": "http://eudres.localhost/board-of-student-representatives",
              "lastmod": "2023-05-16T10:42:37+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/bootcamp-2022",
              "lastmod": "2022-08-08T14:23:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/bootcamp",
              "lastmod": "2023-04-14T11:11:37+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges",
              "lastmod": "2023-05-05T07:12:27+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/changecorner",
              "lastmod": "2022-08-30T07:30:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/classes",
              "lastmod": "2023-05-03T06:08:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins-testimonials",
              "lastmod": "2022-10-11T08:23:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eit-hei-proposal",
              "lastmod": "2022-08-30T07:23:27+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eudres-forum-2023-registration-successful",
              "lastmod": "2023-06-21T11:17:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/hackathon-2021",
              "lastmod": "2022-08-08T14:24:29+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/hackathon",
              "lastmod": "2023-02-13T14:24:10+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/interview-i-living-labs-2022",
              "lastmod": "2023-03-20T08:06:36+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/invitation-rejected",
              "lastmod": "2021-10-06T11:42:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/multisense",
              "lastmod": "2023-02-13T13:47:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/newsletter-19-05-2021",
              "lastmod": "2021-05-18T14:14:11+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/newsletter-23-06-2021",
              "lastmod": "2021-06-22T13:06:25+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/photovoice",
              "lastmod": "2023-03-20T08:07:48+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/privacy-policy",
              "lastmod": "2021-11-26T10:30:44+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/pubquiz",
              "lastmod": "2022-09-06T06:36:02+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/registration-eudres-forum-2023",
              "lastmod": "2023-06-21T11:16:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/registration-successful-eudres-csc-2023",
              "lastmod": "2023-03-22T12:23:17+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researcher-invitation-accepted",
              "lastmod": "2021-10-06T11:36:42+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers",
              "lastmod": "2023-05-03T06:07:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students",
              "lastmod": "2023-05-03T06:06:31+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/virtualgym",
              "lastmod": "2023-02-13T13:48:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/imprint",
              "lastmod": "2023-07-13T12:39:34+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins-open-lectures",
              "lastmod": "2022-12-23T08:43:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/team",
              "lastmod": "2023-01-13T10:30:20+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eudres-infoveranstaltung-fhstp",
              "lastmod": "2023-04-13T12:49:51+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/uashome",
              "lastmod": "2022-12-19T09:18:47+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/achievements",
              "lastmod": "2023-05-16T10:40:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/documents-and-materials",
              "lastmod": "2023-05-03T12:25:09+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins-featured-startups",
              "lastmod": "2023-03-23T16:52:06+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins-inspiring-chat",
              "lastmod": "2022-11-29T14:02:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins",
              "lastmod": "2023-05-16T10:48:28+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eudres-forum-2023",
              "lastmod": "2023-06-21T12:11:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/hackathon-2022",
              "lastmod": "2023-02-13T14:23:11+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/i-living-labs",
              "lastmod": "2023-03-06T07:46:55+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/ideas-and-concepts",
              "lastmod": "2022-09-02T07:54:25+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/privacy-statement",
              "lastmod": "2023-02-09T12:21:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/bootcamp-2023",
              "lastmod": "2023-07-13T13:42:45+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/citizen-science-conference-2023",
              "lastmod": "2023-07-13T13:44:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins_hub_agrifood",
              "lastmod": "2023-07-13T13:44:28+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins_hub_creative_industries",
              "lastmod": "2023-07-13T13:46:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins_hub_digital_health",
              "lastmod": "2023-07-13T13:46:20+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/eins_hub_smart_sustainable_working_learning_environments",
              "lastmod": "2023-07-13T13:47:56+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/get-connected",
              "lastmod": "2023-07-13T13:48:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/iresidency",
              "lastmod": "2023-06-20T06:28:55+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news-and-events",
              "lastmod": "2023-07-11T07:35:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/what-we-do",
              "lastmod": "2023-05-16T10:54:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/who-we-are",
              "lastmod": "2023-05-16T10:55:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/i-living-labs-fall-22",
              "lastmod": "2023-07-13T13:49:02+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/i-living-labs-spring-2023",
              "lastmod": "2023-03-04T08:06:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/european-university-networking-event-austrian-federal-ministry-of-education",
              "lastmod": "2022-10-10T13:43:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-online-opening-conference",
              "lastmod": "2022-10-10T13:49:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/upt-open-education-in-pandemic-times",
              "lastmod": "2022-10-10T13:51:34+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/future-couch-uc-leuven-limburg-uas",
              "lastmod": "2022-10-10T13:54:25+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/regional-stakeholder-workshops-1",
              "lastmod": "2022-10-10T13:57:22+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/second-ucll-future-couch-takes-off",
              "lastmod": "2022-10-10T13:58:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/international-week-vidzeme-university-of-applied-sciences",
              "lastmod": "2022-10-10T14:00:11+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-members-at-eurashe",
              "lastmod": "2022-10-10T14:02:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/third-edition-of-the-ucll-future-couch",
              "lastmod": "2022-10-10T14:05:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/ucll-launches-dutch-e-udres-website",
              "lastmod": "2022-10-10T14:08:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-logo-video",
              "lastmod": "2022-10-10T14:09:50+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-meetings-of-eudres-boards",
              "lastmod": "2022-10-10T14:12:09+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-living-labs",
              "lastmod": "2022-10-10T14:32:22+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-eurashe-annual-conference",
              "lastmod": "2022-10-13T14:43:57+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/fourth-future-couch-gets-artistic",
              "lastmod": "2023-02-02T16:51:55+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-ever-eudres-hackathon",
              "lastmod": "2023-02-02T16:50:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-future-casting-workshop-2",
              "lastmod": "2022-10-13T15:02:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/polytechnic-university-timisoara-flight-festival",
              "lastmod": "2022-11-11T17:14:12+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/mate-hosts-orientation-week-for-international-students",
              "lastmod": "2022-11-11T17:15:51+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/via-at-edufest",
              "lastmod": "2022-11-11T17:18:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-first-ncyan-summit",
              "lastmod": "2023-02-02T16:37:35+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-hackathon-2021",
              "lastmod": "2023-02-02T16:38:43+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-1-year-anniversary",
              "lastmod": "2023-02-02T16:41:35+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-partners-met-at-st-poelten-uas",
              "lastmod": "2023-02-02T16:43:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-i-living-labs",
              "lastmod": "2023-02-02T16:46:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/meeting-of-minister-vidal-with-all-european-university-alliances",
              "lastmod": "2023-02-06T10:50:42+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-science-pub-quiz-dec-21",
              "lastmod": "2023-02-06T10:54:11+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/i-living-labs-are-ending-in-a-showdown",
              "lastmod": "2023-02-06T10:57:23+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eins-inspiring-chat-on-31-january",
              "lastmod": "2023-02-06T11:41:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/new-years-eve-change-corner-activities-at-vidzeme-university-of-applied-sciences-via",
              "lastmod": "2023-02-06T12:27:19+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-forum-of-universities-for-the-future-of-europe",
              "lastmod": "2023-02-16T08:06:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-science-pub-quiz-2",
              "lastmod": "2023-02-16T08:09:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/hannes-raffaseder-and-diana-andone-discuss-the-future-of-wr",
              "lastmod": "2023-02-16T08:11:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-alliance-welcomes-new-partners",
              "lastmod": "2023-02-16T08:24:47+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/e-udres-european-university-alliance-enlargement-ceremony",
              "lastmod": "2022-11-11T17:22:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eins-in-amsterdam",
              "lastmod": "2022-09-14T11:41:08+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/the-change-corner-at-foodconf",
              "lastmod": "2022-09-14T11:38:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-education-and-innovation-summit",
              "lastmod": "2022-09-14T11:36:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-joins-campus-of-european-universities",
              "lastmod": "2022-09-14T11:34:43+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-strategy-forum-at-st-poelten-uas",
              "lastmod": "2022-09-05T11:50:56+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/new-chair-and-vice-chair-of-e-udres-board-of-student-representatives-elected",
              "lastmod": "2022-09-05T11:44:20+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-bootcamp-2022-teamwork-in-the-austrian-alps",
              "lastmod": "2022-09-02T10:42:31+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/the-change-corner-at-the-via-world-cafe",
              "lastmod": "2023-02-02T16:48:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-supports-startup-village-initiative",
              "lastmod": "2022-09-28T11:32:55+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-in-hasselt",
              "lastmod": "2022-09-26T08:48:30+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-alliance-welcomes-jyvaskyla-uas",
              "lastmod": "2022-09-27T11:18:30+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-mourns-the-loss-of-prof-dr-csaba-fogarassy",
              "lastmod": "2022-10-06T07:28:02+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/mind-set-match-50-students-boosted-their-i-living-lab-ideas-to-a-higher-level-at-ucll-be",
              "lastmod": "2023-06-13T09:56:08+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/esna-panel-discussion-w-hannes-raffaseder",
              "lastmod": "2023-07-13T12:40:35+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/ucll-summer-guests",
              "lastmod": "2023-07-13T12:41:52+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-msca-green-deal-cluster-event",
              "lastmod": "2022-10-13T15:04:29+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/inspiring-meetings-with",
              "lastmod": "2023-02-16T08:12:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-edition-future-students-workshop",
              "lastmod": "2023-02-16T08:14:19+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-statement-on-the-situation-in-ukraine",
              "lastmod": "2023-02-16T08:15:55+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/inaugural-session-of-the-european-student-assembly",
              "lastmod": "2023-02-16T08:18:20+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-science-pub-quiz-3",
              "lastmod": "2023-02-16T08:19:50+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-visit-to-vidzeme-uas",
              "lastmod": "2023-02-16T08:20:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/change-corner-seminars-at-upt",
              "lastmod": "2023-02-16T08:22:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/second-eudres-research-living-labs",
              "lastmod": "2023-02-16T08:23:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-edition-of-international-engagement-circus-stops-at-ucll",
              "lastmod": "2023-02-16T08:27:29+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/the-first-eudres-bootcamp-is-coming",
              "lastmod": "2023-02-16T08:28:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-rectors-meeting-with-commissioner-gabriel",
              "lastmod": "2023-02-16T08:30:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/upt-signs-collaboration-agreements-with-german-higher-education-institutions",
              "lastmod": "2023-02-16T08:32:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-st-poelten-uas-lange-nacht-der-forschung",
              "lastmod": "2023-02-16T08:34:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/st-poelten-uas-and-uc-leuven-limburg-uas-nominated-in-triple-e-awards",
              "lastmod": "2023-02-16T08:36:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/europa-forum-wachau-2022",
              "lastmod": "2022-09-05T11:49:51+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/hannes-raffaseder-talks-innovation-and-entrepreneurship-with-science-business",
              "lastmod": "2022-09-05T11:43:17+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/youth-entrepreneurship-week-gave-students-a-glimpse-into-the-world-of-entrepreneurship",
              "lastmod": "2022-10-11T10:42:44+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/experiencing-research-up-close-at-the-european-researchers-night",
              "lastmod": "2022-12-07T16:21:31+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-alliance-celebrates-2nd-anniversary",
              "lastmod": "2022-10-31T10:59:30+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-at-the-st-poelten-uas-international-week",
              "lastmod": "2022-11-30T12:32:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-eudres-regional-stakeholders-forum-took-place-in-austria",
              "lastmod": "2022-12-05T09:55:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/uas4europe-paper-presentation-featured-eudres",
              "lastmod": "2022-12-05T07:41:21+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eins-student-startup-pitching-session",
              "lastmod": "2023-01-11T12:17:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/team-members-of-work-package-innovators-and-entrepreneurs-met-in-portugal",
              "lastmod": "2023-01-24T10:43:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-alliance-enters-next-phase",
              "lastmod": "2023-02-02T12:26:09+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-ent-r-e-novators-project-meets-in-austria-to-work-on-joint-research-strategies",
              "lastmod": "2023-02-21T12:51:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/digital-culture-and-heritage-talks-e-udres-at-spotlight-heritage-timisoara-at-upt",
              "lastmod": "2023-03-01T13:46:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/i-living-labs-on-air-lisa-recnik-and-student-lidia-goro-at-campustalk",
              "lastmod": "2023-03-02T17:33:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eins-wicked-architect-card-game",
              "lastmod": "2023-05-11T06:47:42+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/family-day-at-ucll",
              "lastmod": "2023-06-22T07:00:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/student-teams-presented-their-concepts-in-successful-i-living-lab-showdown",
              "lastmod": "2023-06-02T09:54:52+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eins-augmented-reality-workshop-unlocking-the-innovative-future-of-storytelling",
              "lastmod": "2023-06-02T09:56:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-at-eaie-2022",
              "lastmod": "2023-07-13T13:12:12+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/expert-huddle-supporting-entrepreneurship-and-innovation-in-higher-education-institutions",
              "lastmod": "2023-07-05T11:05:22+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eins-at-eit-hei-initiative-sense-making-workshop",
              "lastmod": "2022-12-16T13:29:20+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-lead-coordinator-joins-meeting-of-rectors-of-european-university-alliances",
              "lastmod": "2023-02-06T10:42:26+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-representatives-met-with-mariya-gabriel",
              "lastmod": "2023-02-27T07:49:06+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/ent-r-e-novators-kicks-off-in-setubal",
              "lastmod": "2023-07-13T13:16:24+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-maps-out-future-in-timisoara",
              "lastmod": "2022-10-25T12:34:08+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/iresidency",
              "lastmod": "2022-12-07T09:30:23+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/latvia-hosted-eudres-intensive-i-living-labs",
              "lastmod": "2023-05-15T07:54:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/team-efishient-wins-top-prize-at-e-udres-hackathon-2022",
              "lastmod": "2023-02-13T14:49:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-attended-euniwell-assembly-in-budapest",
              "lastmod": "2022-10-28T07:52:44+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-animated-video-out-now",
              "lastmod": "2022-12-20T13:54:51+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/showdown-of-the-third-round-of-eudres-i-living-labs",
              "lastmod": "2023-02-10T12:36:44+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/hannes-raffaseder-writes-about-rural-universities-pushing-innovation-in-latest-eaie-blog-post",
              "lastmod": "2023-01-31T14:58:50+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/third-edition-of-the-eudres-research-living-labs-is-coming-up-this-march",
              "lastmod": "2023-02-28T08:15:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-at-the-european-learning-and-teaching-forum-2023",
              "lastmod": "2023-02-10T08:21:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-joins-saxion-uas-in-celebrating-internationalisation-at-the-global-village-festival",
              "lastmod": "2023-02-21T13:08:37+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/10th-edition-of-the-international-workshop-open-education-week-2023-at-upt",
              "lastmod": "2023-03-14T13:23:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-at-the-st-poelten-uas-open-day",
              "lastmod": "2023-03-15T12:08:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-in-person-meeting-of-uashome-boosting-innovation-in-digital-health",
              "lastmod": "2023-03-28T07:29:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/from-idea-to-start-up-joint-lecture-by-eins-and-eit-jumpstarter-at-the-young-talents-international-conference-28th-march-2023",
              "lastmod": "2023-03-30T14:31:19+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/latest-activities-in-human-contribution-to-artificial-intelligence-research-network",
              "lastmod": "2023-04-04T14:04:08+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-joins-enlight-alliance-conference-in-bilbao",
              "lastmod": "2023-04-05T11:04:23+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/connecting-european-regions-fh-forschungsforum-brought-together-austrian-members-of-european-university-alliances",
              "lastmod": "2023-04-21T10:03:29+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/european-universities-drive-innovation-with-coalition-of-the-willing",
              "lastmod": "2023-05-02T12:16:45+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/hannes-raffaseder-joins-conference-on-european-universities-in-bergen",
              "lastmod": "2023-05-08T08:27:52+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-international-engagement-circus-at-ips",
              "lastmod": "2023-06-30T09:50:28+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-iresidency-2023-an-intensive-week-on-start-up-villages",
              "lastmod": "2023-05-24T10:46:11+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-representatives-discuss-regional-innovation-at-uas4europe-networking-conference",
              "lastmod": "2023-05-25T09:43:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/first-eudres-international-citizen-science-conference-to-take-place-in-portugal",
              "lastmod": "2023-06-30T09:56:38+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/openglam-culture-hackathon-at-the-fh-st-poelten",
              "lastmod": "2023-06-22T08:03:57+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-at-udice-forum-in-paris",
              "lastmod": "2023-06-23T12:17:54+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/hannes-raffaseder-elected-as-president-of-eurashe",
              "lastmod": "2023-06-29T14:19:51+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/hannes-raffaseder-speaks-at-european-education-and-innovation-summit",
              "lastmod": "2023-07-06T13:26:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/kicking-off-the-future-of-eudres-proposal-for-eudres-2-0-approved-by-european-commission",
              "lastmod": "2023-07-06T13:24:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eins-on-the-radio-supporting-for-start-ups-in-austria-and-beyond",
              "lastmod": "2023-03-06T12:17:34+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/news/eudres-future-casting-workshop-1",
              "lastmod": "2022-10-10T13:46:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/how-might-we-encourage-the-elderly-to-talk-about-their-biography",
              "lastmod": "2023-05-05T07:06:06+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/how-might-we-promote-resource-saving-and-sustainable-mobility",
              "lastmod": "2023-05-05T07:09:10+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/how-might-we-use-digital-technologies-to-improve-health-literacy-for-the-prevention-of-cardiovascular-diseases",
              "lastmod": "2023-05-05T07:08:57+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/sustainable-farming-in-times-of-climate-change",
              "lastmod": "2023-05-05T07:08:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/transition-of-person-centred-interprofessional-care",
              "lastmod": "2023-05-05T07:07:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/udoti-initiative",
              "lastmod": "2023-05-05T07:10:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/using-ai-to-find-the-right-talents-that-fit-our-company",
              "lastmod": "2023-05-05T07:06:38+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/artificial-intelligence-and-digital-tools-for-pest-control-in-vineyards",
              "lastmod": "2023-07-13T08:00:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/enriching-the-wellbeing-of-smart-city-inhabitants",
              "lastmod": "2023-05-05T07:05:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/nena-the-neighborhood-network",
              "lastmod": "2023-05-05T07:08:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/efficient-collection-of-biodegradable-waste",
              "lastmod": "2023-05-05T07:09:54+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/edit-challenge",
              "lastmod": "2021-09-29T18:06:44+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/classes/edit-class",
              "lastmod": "2021-11-19T11:54:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/edit-researcher",
              "lastmod": "2021-09-29T18:04:50+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students/edit-student",
              "lastmod": "2021-11-19T11:54:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/classes/register-class",
              "lastmod": "2021-11-11T10:00:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/register-researcher",
              "lastmod": "2022-11-29T14:55:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students/register-student",
              "lastmod": "2021-11-11T10:00:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/challenges/submit-challenge",
              "lastmod": "2023-02-10T12:55:02+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/adrienn-toth",
              "lastmod": "2022-01-12T06:03:20+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/agita-livina",
              "lastmod": "2021-11-29T10:26:30+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/agnese-davidsone",
              "lastmod": "2022-02-01T16:55:57+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/aigars-andersons",
              "lastmod": "2022-02-01T17:05:34+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/aija-cunska",
              "lastmod": "2022-03-14T14:58:14+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/alexandra-anderluh",
              "lastmod": "2022-07-25T11:39:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/an-nackom",
              "lastmod": "2022-10-31T09:25:12+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ana-castro",
              "lastmod": "2021-11-29T10:29:17+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ana-claudia-cavaco-de-sousa-coelho",
              "lastmod": "2022-04-04T09:13:37+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ana-filipa-poeira",
              "lastmod": "2021-11-29T10:41:52+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ana-lucia-caeiro-ramos",
              "lastmod": "2022-03-03T14:26:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ana-mata",
              "lastmod": "2021-11-29T10:46:42+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ana-pereira",
              "lastmod": "2021-11-29T10:47:34+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/andreas-jakl",
              "lastmod": "2021-11-29T10:47:44+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/andreia-ferreri-cerqueira",
              "lastmod": "2021-11-29T10:47:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/andrew-nash",
              "lastmod": "2021-11-29T10:48:02+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/andris-lapans",
              "lastmod": "2022-02-04T11:45:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/angelika-beirer",
              "lastmod": "2021-11-29T10:48:22+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/anghel-cernescu",
              "lastmod": "2021-11-29T10:48:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ann-reulens",
              "lastmod": "2022-03-18T14:10:24+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/anna-broka",
              "lastmod": "2021-11-29T10:48:47+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/anna-letournel",
              "lastmod": "2021-11-29T11:42:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/anne-torn-laapio",
              "lastmod": "2023-05-24T05:40:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/antonio-abreu",
              "lastmod": "2021-11-29T10:49:10+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/anzela-jurane-bremane",
              "lastmod": "2022-02-16T13:47:37+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/attila-gere",
              "lastmod": "2021-11-29T10:49:56+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/barbara-biro",
              "lastmod": "2021-11-29T10:50:48+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/barbara-klinser-kammerzelt",
              "lastmod": "2021-11-29T10:51:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/barbara-wondrasch",
              "lastmod": "2021-11-29T10:51:14+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/beatrix-szabo-notin",
              "lastmod": "2021-11-29T10:51:25+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/bernward-asprion",
              "lastmod": "2022-05-16T12:57:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/brian-horsak",
              "lastmod": "2021-11-29T10:51:36+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/carla-alexandra-gamelas-albuquerque-pinto-reis",
              "lastmod": "2022-02-04T11:46:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/carla-pereira",
              "lastmod": "2021-11-29T10:51:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/carmen-caeiro",
              "lastmod": "2021-11-29T10:52:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/carsten-muller",
              "lastmod": "2023-02-28T14:28:45+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/caterine-schwab",
              "lastmod": "2021-11-29T10:52:19+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/celia-soares",
              "lastmod": "2021-11-29T11:42:36+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/christoph-redelsteiner",
              "lastmod": "2021-11-29T14:59:56+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/cosmin-cernazanu",
              "lastmod": "2022-05-16T12:56:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/cosmin-codrean",
              "lastmod": "2021-11-29T10:53:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/crisan-vida-mihaela",
              "lastmod": "2022-04-20T12:29:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/cristian-moldovan",
              "lastmod": "2021-11-29T11:35:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/cristina-sorina-stangaciu",
              "lastmod": "2023-02-10T13:44:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dalma-gerene-radvanyi",
              "lastmod": "2021-11-29T10:54:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dan-ioan-stoia",
              "lastmod": "2022-05-10T10:32:11+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dave-sere",
              "lastmod": "2022-03-18T14:15:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/david-alexandre-mendes-da-silva-simoes",
              "lastmod": "2022-11-29T14:59:58+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/david-papp",
              "lastmod": "2022-03-29T09:42:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dina-caetano-alves",
              "lastmod": "2021-11-29T10:55:11+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/diogo-moco",
              "lastmod": "2023-05-03T06:18:34+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dora-szekely",
              "lastmod": "2021-11-29T10:59:45+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dorian-stef",
              "lastmod": "2021-11-29T10:55:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dr-bela-palyi",
              "lastmod": "2022-03-29T09:42:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/dr-iman-mirmazloum",
              "lastmod": "2022-03-29T09:41:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/edgar-canais",
              "lastmod": "2021-11-29T10:59:59+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/eduardo-b-cruz",
              "lastmod": "2021-11-29T11:00:17+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/elisabeth-enengl",
              "lastmod": "2021-11-29T11:00:29+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/elisabeth-hoeld",
              "lastmod": "2021-11-29T11:00:43+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/elod-kondorosy",
              "lastmod": "2022-03-29T09:40:21+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/evelien-bossuyt",
              "lastmod": "2022-07-04T06:00:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/fernanda-maria-gomes-da-costa-teixeira-marques",
              "lastmod": "2021-11-29T11:00:58+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/fernando-angelino",
              "lastmod": "2023-02-24T08:49:16+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/florian-zahorka",
              "lastmod": "2021-11-29T11:01:08+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/gabriella-kisko",
              "lastmod": "2021-11-29T11:02:27+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/harald-rametsteiner",
              "lastmod": "2021-11-29T11:02:45+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/harald-wimmer",
              "lastmod": "2021-11-29T11:02:59+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/helena-germano",
              "lastmod": "2021-11-29T14:39:23+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/helmut-kammerzelt",
              "lastmod": "2021-11-29T11:03:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/hirut-grossberger",
              "lastmod": "2021-11-29T11:04:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/hugo-franco",
              "lastmod": "2022-04-11T11:30:51+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ildiko-bata-vidacs",
              "lastmod": "2021-11-29T11:04:43+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ilona-beliatskaya",
              "lastmod": "2022-04-13T12:35:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ilse-fraussen",
              "lastmod": "2022-09-05T12:53:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ilse-van-den-berckt",
              "lastmod": "2022-07-04T06:01:31+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ion-dragos-utu",
              "lastmod": "2021-11-29T11:05:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/iveta-steinberga",
              "lastmod": "2021-11-29T11:05:43+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/izabella-olah",
              "lastmod": "2021-11-29T11:05:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jaana-paltamaa",
              "lastmod": "2023-05-03T06:23:57+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jakob-doppler",
              "lastmod": "2021-11-29T11:06:02+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jamilya-nurgazina",
              "lastmod": "2022-10-14T09:50:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jan-van-dierdonck",
              "lastmod": "2022-10-03T10:47:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/janis-bikse-via",
              "lastmod": "2021-11-16T12:23:47+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/janis-bikse",
              "lastmod": "2021-11-16T12:45:06+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/janis-buholcs",
              "lastmod": "2022-03-14T14:42:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/joana-luis-refoios-de-noronha-tudella",
              "lastmod": "2022-04-13T12:38:38+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/joanna-ozga",
              "lastmod": "2023-06-23T08:04:04+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/joaquim-gronita",
              "lastmod": "2022-04-13T12:35:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/johanna-rakaseder",
              "lastmod": "2021-11-29T11:06:50+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/johannes-pflegerl",
              "lastmod": "2021-11-29T11:07:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jose-afonso",
              "lastmod": "2021-11-29T11:07:57+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jose-palma",
              "lastmod": "2021-11-29T11:08:20+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jose-tummers",
              "lastmod": "2022-03-18T14:17:52+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/jutta-kutrovatz",
              "lastmod": "2021-11-29T11:08:45+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/kaspars-osis",
              "lastmod": "2022-03-14T16:16:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/katalin-badakne-kerti",
              "lastmod": "2022-05-04T09:57:58+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/katrien-vandael",
              "lastmod": "2022-05-23T07:32:57+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/kevin-dadaczynski",
              "lastmod": "2023-02-24T09:00:34+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/laszlo-baranyai",
              "lastmod": "2021-11-29T11:19:48+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/lilla-szaloki-dorko",
              "lastmod": "2021-11-29T11:09:12+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/linda-lancere",
              "lastmod": "2021-11-29T11:09:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/linda-veliverronena",
              "lastmod": "2021-11-29T11:10:28+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/livia-simon-sarkadi",
              "lastmod": "2021-11-29T11:15:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/lotte-ovaere",
              "lastmod": "2022-03-18T14:18:54+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/lucilia-nunes",
              "lastmod": "2021-11-29T11:15:59+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/luis-antunes-gomes",
              "lastmod": "2021-11-29T11:17:01+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/luis-manuel-rodrigues-coelho",
              "lastmod": "2022-02-18T12:37:08+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/luisa-carvalho",
              "lastmod": "2021-11-15T11:27:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/lukas-daniel-klausner",
              "lastmod": "2021-11-29T11:16:14+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/lukas-richter",
              "lastmod": "2021-11-29T11:16:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/madalena-gomes-silva",
              "lastmod": "2021-11-29T11:20:06+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/maira-lescevica",
              "lastmod": "2022-03-14T16:09:07+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/marc-birringer",
              "lastmod": "2023-02-24T09:05:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/marcia-santos",
              "lastmod": "2022-03-03T14:16:10+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/marco-l-marques",
              "lastmod": "2021-11-29T11:20:31+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/maria-catarina-paz",
              "lastmod": "2022-04-13T12:36:03+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/maria-de-fatima-serralha",
              "lastmod": "2021-11-29T11:37:09+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/maria-leonor-pires",
              "lastmod": "2021-11-29T11:21:26+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/mariella-seel",
              "lastmod": "2021-11-29T11:22:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/mario-espada",
              "lastmod": "2022-02-16T13:49:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/mario-heller",
              "lastmod": "2021-11-29T11:22:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/mark-simonlehner",
              "lastmod": "2021-11-29T15:02:32+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/marta-zsuzsanna-pasztor",
              "lastmod": "2022-03-29T09:41:48+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/matthias-zeppelzauer",
              "lastmod": "2021-11-29T11:23:01+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/michael-bauwens",
              "lastmod": "2022-07-04T06:03:35+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/michael-iber",
              "lastmod": "2021-11-29T11:23:22+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/michael-litschka",
              "lastmod": "2021-11-29T11:24:23+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/michaela-moser",
              "lastmod": "2021-11-29T15:24:12+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/miguel-guevara",
              "lastmod": "2021-11-29T11:25:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/mohcine-boudhane",
              "lastmod": "2021-11-29T11:25:22+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/monica-buzdugan",
              "lastmod": "2021-11-29T11:37:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/monika-kovarova-simecek",
              "lastmod": "2021-11-29T11:25:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/monika-mate",
              "lastmod": "2021-11-29T11:25:55+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/nelson-jorge-gaudencio-carrico",
              "lastmod": "2022-03-03T14:30:35+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/nilmara-russo-braz-dos-santos-dias",
              "lastmod": "2022-04-04T09:17:56+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/nora-adanyine-kisbocskoi",
              "lastmod": "2021-11-29T11:27:09+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/norbert-gal-nadasan",
              "lastmod": "2022-04-11T11:28:14+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/nuno-pereira",
              "lastmod": "2021-11-29T14:56:38+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/olgierd-swiatkiewicz",
              "lastmod": "2021-11-29T14:54:30+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/oskars-java",
              "lastmod": "2021-11-29T11:28:21+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/pamela-nolz",
              "lastmod": "2021-11-11T07:19:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/patricia-renner",
              "lastmod": "2021-11-29T11:28:39+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/pedro-albuquerque-santos",
              "lastmod": "2021-11-29T11:29:01+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/pedro-belo",
              "lastmod": "2022-01-10T14:42:21+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/peter-vanbrabant",
              "lastmod": "2022-07-04T06:05:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/petra-plunger",
              "lastmod": "2021-11-29T11:29:18+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/raquel-barreira",
              "lastmod": "2021-11-10T13:03:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/razvan-bogdan",
              "lastmod": "2022-04-11T11:29:12+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/ricardo-salgado",
              "lastmod": "2022-02-04T11:49:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/rita-fernandes",
              "lastmod": "2021-11-29T11:29:36+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/robrecht-van-goolen",
              "lastmod": "2022-09-05T12:59:09+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/sandrina-b-moreira",
              "lastmod": "2021-11-29T11:30:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/sara-gilissen",
              "lastmod": "2022-03-18T14:24:45+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/sarah-de-coninck",
              "lastmod": "2022-03-18T14:22:41+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/sarma-cakula",
              "lastmod": "2022-02-16T14:01:19+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/sarmite-rozentale",
              "lastmod": "2022-04-11T10:39:26+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/sebastian-oetzel",
              "lastmod": "2023-02-28T14:25:37+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/sergiu-valentin-galatanu",
              "lastmod": "2022-03-18T14:27:51+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/siegmund-leducq",
              "lastmod": "2022-09-05T12:54:58+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/stamatia-devetzi",
              "lastmod": "2023-02-28T14:33:13+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/susanne-roiser",
              "lastmod": "2021-11-29T11:30:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/szilard-berke",
              "lastmod": "2021-11-29T11:30:49+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/tassilo-pellegrini",
              "lastmod": "2021-11-29T11:31:06+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/tatjana-aubram",
              "lastmod": "2021-11-29T11:31:19+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/teresa-costa",
              "lastmod": "2021-11-29T11:31:31+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/thomas-felberbauer",
              "lastmod": "2021-11-29T11:31:53+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/tobias-knedlik",
              "lastmod": "2023-02-24T08:50:46+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/tuomo-sipola",
              "lastmod": "2023-03-30T15:47:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/vanessa-leung",
              "lastmod": "2021-11-29T11:42:01+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/veronique-bockstal",
              "lastmod": "2022-09-05T12:56:50+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/viktor-varju",
              "lastmod": "2023-05-02T13:19:00+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/vineta-silkane",
              "lastmod": "2022-02-01T17:14:06+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/wolfgang-aigner",
              "lastmod": "2021-11-29T11:32:24+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/yasmine-sterckx",
              "lastmod": "2022-03-29T09:41:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/zahra-mesbahi",
              "lastmod": "2023-02-06T13:13:05+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/zoltan-kokai",
              "lastmod": "2021-11-29T11:32:55+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/zoltan-kovacs",
              "lastmod": "2021-11-29T11:32:40+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/researchers/zora-annamaria-nagy",
              "lastmod": "2022-04-04T09:19:59+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students/abdul-hannan-bin-zulkarnain",
              "lastmod": "2023-05-24T05:45:33+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students/estera-valean",
              "lastmod": "2022-07-25T11:39:36+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students/lara-sklenarz",
              "lastmod": "2022-05-30T14:11:37+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students/lukas-kroisenbrunner",
              "lastmod": "2021-12-02T09:38:15+00:00",
              "priority": 0.8
            },
            {
              "loc": "http://eudres.localhost/students/madroane-denis-florin",
              "lastmod": "2022-04-04T09:20:58+00:00",
              "priority": 0.8
            }
          ]
        }
      };

    let errorSites = [];
    sitemap.urlset.url.forEach(async (site) => {
        const response = await fetch(site.loc);
        if (!response.ok) {
            errorSites.push(site.loc);
        }
        console.log(site.loc);
    });
}

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);

